import { PaginatedData } from "../hooks/PaginationHooks";
import { GenericInAppNotification, GenericInAppNotificationResponse, NotificationWithPagination } from "../types/notificationType";
import { PaginationParameters, toQueryParameters } from "./Pagination";
import { CallResult, doApiDelete, doApiGet, doApiPatch, doApiPost } from "./Requests";


export const notificationApi = {
    getUnreadNotificationAmount: (): Promise<CallResult<number>> =>
        doApiGet<number>(`/api/users/current/notifications/count`),

    getNotificationList: (
        offset: number,
        limit: number,
        status: string
    ): Promise<CallResult<NotificationWithPagination>> =>
        doApiGet<NotificationWithPagination>(
            `/api/users/current/notifications?offset=${offset}&limit=${limit}&status=${status}`
        ),

    editNotificationVisibility: (
        id: number,
        status: string
    ): Promise<CallResult<void>> =>
        doApiPatch<string, void>(`/api/users/current/notifications/${id}/status`, status),

    getGenericInAppNotifications: (pagination: PaginationParameters): Promise<CallResult<PaginatedData<GenericInAppNotificationResponse>>> =>
        doApiGet<PaginatedData<GenericInAppNotificationResponse>>(`/api/companies/current/notifications?${toQueryParameters(pagination)}`),

    getGenericInAppNotification: (id: number): Promise<CallResult<GenericInAppNotificationResponse>> =>
        doApiGet<GenericInAppNotificationResponse>(`/api/companies/current/notifications/{id}`),

    createGenericInAppNotification: (updatedNotification: GenericInAppNotification): Promise<CallResult<void>> =>
        doApiPost<GenericInAppNotification, never>(`/api/companies/current/notifications`, updatedNotification),

    updateGenericInAppNotification: (id: number, updatedNotification: GenericInAppNotification): Promise<CallResult<void>> =>
        doApiPatch<GenericInAppNotification, never>(`/api/companies/current/notifications/${id}`, updatedNotification),

    deleteGenericInAppNotification: (id: number): Promise<CallResult<void>> =>
        doApiDelete<never>(`/api/companies/current/notifications/${id}`),
};